import LayoutContentArea from "@/components/layout/LayoutContentArea";
import RequestStateLevelExtractCard from "@/components/state-level-data-view/RequestStateLevelExtractCard";
import StateLevelExtractsCard from "@/components/state-level-data-view/StateLevelExtractsCard";

export default function StateLevelDataViewPage() {
  return (
    <LayoutContentArea headingText="State Level Data View">
      <RequestStateLevelExtractCard />
      <StateLevelExtractsCard />
    </LayoutContentArea>
  );
}
